module.exports = __webpack_public_path__ + "img/大雪-暴雪.03eea68e.png";